import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/ui/Button';

export default function NotFound() {
  // CO-857: rendered by the catch-all route inside the signed-in shell (App.tsx); the test id is what specs assert on.
  // Quiet by design: the code is a muted label, the sentence is the heading, and the one way out is home.
  // Centred text and logical spacing only, so the page reads the same in RTL.
  const { t } = useTranslation();
  return (
    <div data-testid="not-found-page" className="flex flex-col items-center justify-center px-6 py-24 text-center">
      <p className="text-4xl font-semibold tabular-nums tracking-tight text-muted-foreground" aria-hidden="true">404</p>
      <h1 className="mt-3 max-w-[48ch] text-base font-medium text-foreground" data-testid="not-found-message">
        {t('notFound.message')}
      </h1>
      <Button asChild variant="outline" size="sm" iconName="Home" className="mt-6">
        <Link to="/" data-testid="not-found-home-link">{t('notFound.goHome')}</Link>
      </Button>
    </div>
  );
}
